import Reader from './component';
import _routes from './routes';

export const routes = _routes;

export default Reader;



// WEBPACK FOOTER //
// ./containers/Group/Homework/Reader/index.js